import { Search, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export interface FilterDef {
  key: string
  label: string
  type: 'search' | 'select'
  options?: Array<{ value: string; label: string }>
  placeholder?: string
}

interface FilterBarProps {
  filters: FilterDef[]
  values: Record<string, string>
  onChange: (key: string, value: string) => void
  onClear: () => void
}

export function FilterBar({ filters, values, onChange, onClear }: FilterBarProps) {
  const hasActive = Object.values(values).some((v) => v !== '')

  return (
    <div className="flex flex-wrap items-center gap-3">
      {filters.map((f) =>
        f.type === 'search' ? (
          <div key={f.key} className="relative">
            <Search className="absolute left-3 top-2.5 h-4 w-4" style={{ color: 'var(--color-text-tertiary)' }} />
            <input
              type="text"
              placeholder={f.placeholder ?? `Buscar ${f.label.toLowerCase()}...`}
              value={values[f.key] ?? ''}
              onChange={(e) => onChange(f.key, e.target.value)}
              className="rounded-md border py-2 pl-9 pr-3 text-sm"
              style={{ borderColor: 'var(--color-border)', minWidth: '220px' }}
            />
          </div>
        ) : (
          <select
            key={f.key}
            value={values[f.key] ?? ''}
            onChange={(e) => onChange(f.key, e.target.value)}
            className="rounded-md border px-3 py-2 text-sm"
            style={{ borderColor: 'var(--color-border)' }}
          >
            <option value="">{f.label}: Todos</option>
            {f.options?.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        ),
      )}
      {hasActive && (
        <Button variant="ghost" size="sm" onClick={onClear}>
          <X className="h-3.5 w-3.5" /> Limpiar
        </Button>
      )}
    </div>
  )
}
